import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class ReporteService {
  async getVentasPorCanal(parametros) {
    // Para peticiones GET, construimos los parámetros en la URL
    const queryString = new URLSearchParams(parametros).toString();
    const data = await fetchWrapper.get(`${ruta}/reportes/ventas-por-canal?${queryString}`);
    return data;
  }

  async getRankingSucursales(parametros) {
    const queryString = new URLSearchParams(parametros).toString();
    const data = await fetchWrapper.get(`${ruta}/reportes/ranking-sucursales?${queryString}`);
    return data;
  }

  async getVentasDelMes(parametros){
    const queryString = new URLSearchParams(parametros).toString();
    const data = await fetchWrapper.get(`${ruta}/reportes/ventas-del-mes?${queryString}`);
    return data;
  }

  async getTicketPromedio(parametros){
    const queryString = new URLSearchParams(parametros).toString();
    const data = await fetchWrapper.get(`${ruta}/reportes/ticket-promedio?${queryString}`);
    return data;
  }

  //reporte en el modulo ventas
  async productosMasVendidos(parametros){
    const queryString = new URLSearchParams(parametros).toString();
    const data = await fetchWrapper.get(`${ruta}/productosMasVendidos?${queryString}`);
    return data;
  }
}
